import { createStore, applyMiddleware, combineReducers } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk'

import AuthReducer from './Auth/AuthReducer';
import LoadingReducer from './Loading/LoadingReducer';
import ToastReducer from './Toast/ToastReducer';
import cartReducer from './Cart/CartReducer';
import systemDataReducer from './SystemData/systemDataReducer';
// import TrafficReducer from './Traffic/TrafficReducer';

const initialState = {}

// TEMP DIAGNOSTIC: logs every dispatched action + which top-level slices changed
// reference (a slice changing reference is what forces subscribed components to
// re-render). Remove once we've found the culprit.
const actionLogger = (store) => (next) => (action) => {
    const before = store.getState();
    const result = next(action);
    const after = store.getState();
    const changed = Object.keys(after).filter((k) => after[k] !== before[k]);
    // eslint-disable-next-line no-console
    console.log(
        `%c[action] ${action.type}%c changed: [${changed.join(', ') || 'nothing'}]`,
        'color:#10b981;font-weight:bold',
        'color:#888'
    );
    return result;
};

const middleware = [thunk, actionLogger]
const rootReducer = combineReducers({
    auth: AuthReducer,
    loading: LoadingReducer,
    toast: ToastReducer,
    systemData: systemDataReducer,
    cart: cartReducer,
    // aiGen:AiGenReducer,
    // traffic: TrafficReducer,

})

const Store = createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(...middleware)));
// const store = createStore(rootReducer, initionState, applyMiddleware(...middleware))

export default Store